module.exports = __webpack_public_path__ + "assets/img/TLSC2-1.cf69e909.jpg";